import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CpslButton, CpslIcon, CpslInput, CpslText } from '@usecapsule/react-components';
import { useCallback } from 'react';
import { styled } from 'styled-components';
import { ModalStep } from '../utils/steps.js';
import { useModalStore } from '../stores/index.js';
export const AddFundsButton = ({ text = 'Add Funds' }) => {
    const setStep = useModalStore(state => state.setStep);
    const onRampConfig = useModalStore(state => state.onRampConfig);
    const onClick = useCallback(() => {
        setStep(ModalStep.ADD_FUNDS);
    }, [onRampConfig]);
    return (_jsx(CpslButton, { variant: "secondary", fullWidth: true, onClick: onClick, children: _jsxs(ButtonWithIconContainerInvert, { children: [_jsx(AddFundsIcon, { icon: "plusCircle" }), text] }) }));
};
const AddFundsIcon = styled(CpslIcon) `
  margin-top: -1px;
  margin-right: 2px;

  cpsl-icon {
    --icon-color: var(--cpsl-color-text-primary);
  }
`;
export const SpinnerContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 16px 0px;
  margin: 4px 0px;
`;
export const Hero = styled(CpslIcon) `
  box-sizing: content-box;
  align-self: center;
  --height: 64px;
  --width: 64px;
  --icon-fill-color: var(--cpsl-color-foreground-0);

  padding: 16px 0px;
  margin: 4px 0px;
`;
export const HeroNoSpacing = styled(Hero) `
  padding: 0px;
  margin: 0px;
`;
export const Heading = styled(CpslText) `
  text-align: center;
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  letter-spacing: 0.72px;
`;
export const Text = styled(CpslText) `
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-line;
`;
export const SecondaryText = styled(Text) `
  color: var(--cpsl-color-text-secondary);
`;
export const CreationStepSubheading = styled(SecondaryText) `
  max-width: 214px;
`;
export const ClickableText = styled(Text) `
  cursor: pointer;
`;
export const FlexColumn = styled.div `
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;
export const MainContainer = styled(FlexColumn) `
  padding: 0px 16px;
`;
export const QRContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 252px;
`;
export const ButtonWithIconContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  height: 18px;

  cpsl-icon {
    --icon-color: var(--cpsl-color-text-inverted);
  }
`;
export const ButtonWithIconContainerInvert = styled(ButtonWithIconContainer) `
  cpsl-icon {
    --icon-color: var(--cpsl-color-text-primary);
  }
`;
export const InfoBoxContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const InfoBoxHeader = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;

  cpsl-icon {
    --height: 20px;
    --width: 20px;
  }
`;
export const InfoBoxHeading = styled(CpslText) `
  font-size: 16px;
  line-height: 18px;
  font-weight: 500;
`;
export const InfoBoxText = styled(SecondaryText) `
  text-align: left;
  font-weight: 500;
`;
export const FilledDisabledInput = styled(CpslInput) `
  --container-border-color: var(--cpsl-color-input-border-placeholder);
`;
